import guest from "../middleware/guest";

export default [
    {
        path: "/auth",
        name: "auth",
        component: () => {
            return import(
                `../../projects/authentication/App.vue`
            );
        },
        meta: {
            middleware: [guest]
        },
        children: [
            {
                path: "",
                // redirect: "login",
                beforeEnter: () => {
                    window.location.href = "/";
                    return false;
                }
            },
            // {
            //     path: "login",
            //     name: "login",
            //     components: {
            //         subview: () => {
            //             return import(
            //                  "./../../projects/authentication/views/Login.vue"
            //             );
            //         }
            //     },
            //     meta: {
            //         title: "auth.login.title"
            //     }
            // },
            {
                path: "forgotpassword",
                name: "forgotpassword",
                components: {
                    subview: () => {
                        return import(
                             `../../projects/authentication/views/ForgotPassword.vue`
                        );
                    }
                },
                meta: {
                    title: "auth.forgotpassword.title"
                }
            },
            {
                path: "resetpassword/:key/:token",
                name: "resetpassword",
                props: true,
                components: {
                    subview: () => {
                        return import(
                             `../../projects/authentication/views/ResetPassword.vue`
                        );
                    }
                },
                meta: {
                    title: "auth.resetpassword.title"
                }
            }
        ]
    }
];
